import React, { useEffect, useMemo } from "react";
import { RadioButtonsList } from "../../../controls";
import {
  SCHEDULE_TYPES,
  schedulerTypeOptions,
  type ScheduleType,
} from "../SchedulerUtils";

export interface TypeSelectionProps {
  disabled?: boolean;
  selectedType?: ScheduleType;
  onChange: (value: ScheduleType) => void;
  allowedTypes?: ScheduleType[];
  label?: string;
}

const TypeSelection: React.FC<TypeSelectionProps> = ({
  disabled = false,
  selectedType,
  onChange,
  allowedTypes = [
    SCHEDULE_TYPES.DAY,
    SCHEDULE_TYPES.WEEK,
    SCHEDULE_TYPES.MONTH,
  ],
  label,
}) => {
  const options = useMemo(
    () =>
      schedulerTypeOptions.filter(({ name }) => allowedTypes.includes(name)),
    [allowedTypes]
  );

  useEffect(() => {
    if (!selectedType || !allowedTypes.includes(selectedType)) {
      onChange(options[0].value);
    }
  }, []);

  return (
    <RadioButtonsList
      label={label}
      options={options}
      onChange={onChange}
      direction="row"
      value={selectedType}
      data-testid={"scheduler-type-selection"}
      labelTop
      required
      alignLeft
      className="no-padding-bottom"
      disabled={disabled}
    />
  );
};

export default TypeSelection;
